import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { action, observable, computed, runInAction } from 'mobx';
import { task } from 'mobx-task';
import uniq from 'lodash/uniq';
import { validationContext, func, pattern } from 'validx';
import { extractMessageFromError } from '../utils/errorUtil';
var InviteTeamMemberState = (_dec = action.bound, _dec2 = action.bound, _dec3 = task.resolved, _dec4 = action.bound, _class = /*#__PURE__*/function () {
  function InviteTeamMemberState(_ref) {
    var _this = this;
    var invitationStore = _ref.invitationStore,
      teamRoleStore = _ref.teamRoleStore,
      flashMessageStore = _ref.flashMessageStore,
      team = _ref.team,
      teamMemberStore = _ref.teamMemberStore,
      target = _ref.target;
    _classCallCheck(this, InviteTeamMemberState);
    _initializerDefineProperty(this, "showing", _descriptor, this);
    _initializerDefineProperty(this, "email", _descriptor2, this);
    _initializerDefineProperty(this, "teamRoleId", _descriptor3, this);
    _initializerDefineProperty(this, "target", _descriptor4, this);
    this.validation = validationContext(this, {
      email: [func(function () {
        return _this.emailAddresses.length > 0;
      }, 'Please enter at least one email address'), func(function () {
        var fn = pattern('email');
        var invalidEmails = _this.emailAddresses.map(function (e) {
          var isValidEmail = fn({
            obj: _this,
            field: 'email',
            value: e
          }) === true;
          return isValidEmail ? false : e;
        }).filter(Boolean);
        return invalidEmails.length === 0 || invalidEmails.length === 1 && "The following email is invalid: ".concat(invalidEmails) || "The following emails are invalid: ".concat(invalidEmails.join(', '));
      }), func(function () {
        var teamMemberEmails = _this.currentTeamMemberEmailAddresses;
        var alreadyExistsEmails = _this.emailAddresses.filter(function (email) {
          return teamMemberEmails.has(email);
        });
        return alreadyExistsEmails.length === 0 || "The following emails already exist in this team: ".concat(alreadyExistsEmails.join(', '));
      })]
    });
    this.target = target;
    this.invitationStore = invitationStore;
    this.teamRoleStore = teamRoleStore;
    this.flashMessageStore = flashMessageStore;
    this.team = team;
    this.teamMemberStore = teamMemberStore;
    this.sendInvite = this.sendInvite.bind(this);
  }
  return _createClass(InviteTeamMemberState, [{
    key: "teamRoles",
    get: function get() {
      return this.teamRoleStore.forWorkspace(this.team.workspaceId).filter(function (role) {
        return !role.isOwnerRole;
      });
    }
  }, {
    key: "currentTeamMemberEmailAddresses",
    get: function get() {
      return new Set(this.teamMemberStore.forTeam(this.team.id).map(function (_ref2) {
        var member = _ref2.member;
        return member.email;
      }));
    }
  }, {
    key: "show",
    value: function show() {
      this.validation.reset();
      this.showing = true;
      this.email = '';
      this.activate();
    }
  }, {
    key: "emailAddresses",
    get: function get() {
      return uniq(this.email.split(/[,\n]+/g).map(function (e) {
        return e.trim().toLowerCase();
      }).filter(Boolean));
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var role;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.teamRoleStore.fetchTeamRolesForWorkspace(this.team.workspaceId);
            case 2:
              role = this.teamRoles[0];
              this.teamRoleId = role && role.id;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "validate",
    value: function validate() {
      return this.validation.reset().validate().isValid;
    }
  }, {
    key: "sendInvite",
    value: function () {
      var _sendInvite = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var doneCount, emails, totalCount, formatMessage, msg, results, failed, errorMessages;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.validate()) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              // Track how many we have sent.
              doneCount = 0;
              emails = this.emailAddresses;
              totalCount = emails.length; // Computes a message every time a request is done
              formatMessage = function formatMessage() {
                return "Sending invitations, ".concat(doneCount, " of ").concat(totalCount, "...");
              };
              msg = this.flashMessageStore.create({
                inProgress: true,
                message: formatMessage()
              });
              _context2.next = 9;
              return Promise.all(emails.map(function (email) {
                return email === 'fail@test.com' ? Promise.resolve({
                  email: email,
                  error: new Error('Oh my, shit happened')
                }) : _this2.invitationStore.invite({
                  workspace_id: _this2.team.workspaceId,
                  team_id: _this2.team.id,
                  team_role_id: _this2.teamRoleId,
                  email: email,
                  target: _this2.target
                }).then(function (data) {
                  doneCount++;
                  _this2.invitationStore.pendingMembers.set(data);
                  msg.set({
                    message: formatMessage()
                  });
                  return {
                    email: email,
                    success: true
                  };
                }).catch(function (err) {
                  return {
                    email: email,
                    error: err
                  };
                });
              }));
            case 9:
              results = _context2.sent;
              failed = results.filter(function (r) {
                return r.error;
              });
              if (!(failed.length === 0)) {
                _context2.next = 15;
                break;
              }
              msg.done(doneCount === 1 ? 'Invite sent!' : "Sent ".concat(doneCount, " invites!")).autoDismiss();
              this.close();
              return _context2.abrupt("return");
            case 15:
              // Report failures, set the email field to the emails that failed.
              runInAction(function () {
                _this2.email = failed.map(function (f) {
                  return f.email;
                }).join(', ');
              });
              errorMessages = failed.map(function (f) {
                return extractMessageFromError(f.error);
              }).join('. ');
              msg.warn(doneCount > 0 ? "Sent ".concat(doneCount, " invites, but ").concat(failed.length, " didn't go through. ").concat(errorMessages) : "None of the invites were sent. ".concat(errorMessages));
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function sendInvite() {
        return _sendInvite.apply(this, arguments);
      }
      return sendInvite;
    }()
  }, {
    key: "close",
    value: function close() {
      this.showing = false;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "teamRoleId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "target", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "teamRoles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamRoles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTeamMemberEmailAddresses", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTeamMemberEmailAddresses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailAddresses", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emailAddresses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendInvite", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "sendInvite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { InviteTeamMemberState as default };
//# sourceMappingURL=InviteTeamMemberState.js.map
